import i18n from '@/main';
import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import EventBus from '@/utils/eventBus';
import { reactive, computed } from 'vue';
import { mascaraCAR } from '@/utils/mascaras';
import { paginarArray, ordenarArray, formatarCpfCnpj } from '../mixins';

const state = reactive({
    itensPorPagina: 10,
    exportando: false,
    resultado: '',
    resultados: [],
    resultadosFiltro: [],
    quantidadeResultados: 0,
    ordemResultados: '',
    colunaOrdenacaoResultados: '',
    paginaResultados: 1
});

function clear() {
    state.itensPorPagina = 10;
    state.exportando = false;
    state.resultado = '';
    state.resultados = [];
    state.quantidadeResultados = 0;
    state.ordemResultados = '';
    state.colunaOrdenacaoResultados = '';
    state.paginaResultados = 1;
    state.resultadosFiltro = [];
}

const listaResultados = computed(() => {
    const filtro = state.resultadosFiltro;
    const resultados = ordenarArray(
        state.resultados.map(item => ({
            ...item,
            cpfCnpj: formatarCpfCnpj(item.cpfCnpj),
            car: mascaraCAR(item.car),
            local: `${item.municipio}/${item.uf}`
        })),
        state.colunaOrdenacaoResultados,
        state.ordemResultados
    );
    const filtrarPorNomes = item => {
        const keys = Object.keys(item);
        return keys.some(key => filtro.includes(String(item[key])));
    };
    const resultadosFiltrados =
        filtro.length > 0 ? resultados.filter(filtrarPorNomes) : resultados;
    const lista = paginarArray(resultadosFiltrados, state.itensPorPagina);
    const totalPaginas = lista.length;

    return {
        data: lista[state.paginaResultados - 1] || [],
        totalItens: resultados.length,
        totalPaginas: totalPaginas
    };
});

function handleSortChangeResults({ prop, order }) {
    state.ordemResultados = order;
    state.colunaOrdenacaoResultados = prop;
}

function handleSortChangeData({ order }) {
    state.ordemDados = order;
}

function mudarPaginaResuldados(paginaResultados) {
    state.paginaResultados = paginaResultados;
}

function loadingScreen(isLoading) {
    const options = {
        mostrarLoading: isLoading,
        lockMessage: i18n.t('mensagens.sistema.carregando')
    };
    EventBus.$emit('emit-componente-carregando', options);
}

async function exportResults(element) {
    loadingScreen(true);
    const content = element;
    const pageResultados = state.paginaResultados;
    const pageDados = state.paginaDados;

    element.classList.add('denuncia-inserir__exportar--processando');
    state.paginaDados = 1;
    state.paginaResultados = 1;
    state.itensPorPagina = 1;
    state.exportando = true;

    setTimeout(async () => {
        const canvas = await html2canvas(content, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new JsPDF('p', 'mm', 'a4');
        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }
        pdf.save(`denuncia.pdf`);

        state.paginaDados = pageDados;
        state.paginaResultados = pageResultados;
        state.itensPorPagina = 10;
        state.exportando = false;

        element.classList.remove('denuncia-inserir__exportar--processando');
        loadingScreen(false);
    }, 1000);
}

function filtarResultados(listaFiltro) {
    state.resultadosFiltro = listaFiltro;
}

function adicionarResultado(resultados) {
    state.resultados = resultados;
    state.quantidadeResultados = new Set(
        resultados.map(d => d.numeroContrato)
    ).size;
    state.resultado = resultados.length > 0 ? 'Positivo' : 'Negativo';
}

const useShareReport = () => {
    return {
        state,
        listaResultados,
        adicionarResultado,
        filtarResultados,
        clear,
        exportResults,
        handleSortChangeResults,
        handleSortChangeData,
        mudarPaginaResuldados
    };
};

export default useShareReport;
